import React from "react";
import { TPosition } from "./Tooltip";

type TCalculatePosition = {
  position: TPosition;
  anchor: DOMRect;
  tooltip: DOMRect;
}

const defaultStyle: React.CSSProperties = { left: 0, top: 0 };
const margin = 10;
const shift = 1.3;

export const calculatePosition = ({ position, anchor, tooltip }: TCalculatePosition) => {
  const scrollY = window.scrollY;
  const scrollX = window.scrollX;

  const top = scrollY + anchor.top;
  const left = scrollX + anchor.left;

  let newTooltipStyle: React.CSSProperties = defaultStyle;
  let newArrowStyle: React.CSSProperties = defaultStyle;

  switch (position) {
  case "leftCenter":
    newTooltipStyle = {
      top: top + (anchor.height / 2) - (tooltip.height / 2),
      left: left + anchor.width + margin
    };
    newArrowStyle = {
      left: -2,
      top: "50%",
      transform: "rotate(90deg)"
    };
    break;
  case "rightCenter":
    newTooltipStyle = {
      top: top + (anchor.height / 2) - (tooltip.height / 2),
      left: left - (tooltip.width / 2) - anchor.width
    };
    newArrowStyle = {
      left: "initial",
      right: "-2px",
      top: "50%",
      transform: "rotate(-90deg)"
    };
    break;
  case "topCenter":
    newTooltipStyle = {
      top: top - tooltip.height - margin,
      left: left - (tooltip.width / 2) + (anchor.width / 2)
    };
    newArrowStyle = {
      left: (tooltip.width / 2) + - margin,
      bottom: "2px",
      top: "initial",
      transform: "rotate(0)"
    };
    break;
  case "bottomCenter":
    newTooltipStyle = {
      top: top + anchor.height + margin,
      left: left - tooltip.height
    };
    newArrowStyle = {
      left: "initial",
      top: "1px",
      transform: "scale(1, -1)"
    };
    break;
  case "topRight":
    newTooltipStyle = {
      top: top - tooltip.height - margin,
      left: left - tooltip.width + (anchor.width / shift)
    };
    newArrowStyle = {
      left: "initial",
      right: "20px",
      top: "initial",
      bottom: "2px",
      transform: "rotate(0)"
    };
    break;
  case "bottomRight":
    newTooltipStyle = {
      top: top + (tooltip.height / 2) - margin,
      left: left - tooltip.width + (anchor.width / shift)
    };
    newArrowStyle = {
      right: "20px",
      left: "initial",
      top: "2px",
      bottom: "initial",
      transform: "scale(1, -1)"
    };
    break;
  default:
    newTooltipStyle = {
      top: top + (anchor.height / 2) - (tooltip.height / 2),
      left: left + anchor.width + margin
    };
    newArrowStyle = {
      left: -2,
      top: "50%",
      transform: "rotate(90deg)"
    };
    break;
  }

  return {
    tooltipStyle: newTooltipStyle,
    arrowStyle: newArrowStyle,
  };
};
